module.exports = __webpack_public_path__ + "static/media/aicte_logo_sign.7391a8c4.png";